const STORAGE_KEY = 'discipline:userId';

/**
 * Returns this device's anonymous identifier, creating one on first run.
 * Every backend call (push subscription, health sync) is namespaced by
 * this id so that multiple people can install the same app without
 * their data colliding.
 */
export function getUserId(): string {
  const existing = localStorage.getItem(STORAGE_KEY);
  if (existing) {
    return existing;
  }

  const generated = crypto.randomUUID();
  localStorage.setItem(STORAGE_KEY, generated);
  return generated;
}
